import { render } from "./LeadsManagementDashboard.vue?vue&type=template&id=2ba4db19"
import script from "./LeadsManagementDashboard.vue?vue&type=script&lang=js"
export * from "./LeadsManagementDashboard.vue?vue&type=script&lang=js"

import "./LeadsManagementDashboard.vue?vue&type=style&index=0&id=2ba4db19&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__